import React, {useState, useEffect} from 'react';
import { useTheme } from '@mui/material/styles';
import { 
  BarChart, 
  Bar, 
  XAxis, 
  YAxis, 
  Label, 
  ResponsiveContainer,
   } from 'recharts';
import InfoIcon from '@mui/icons-material/Info';
import {
  IconButton,
  Grid,
  Tooltip
} from '@mui/material';
import {Tooltip as TooltipRecharts} from 'recharts';
import Title from '../../../../components/Title';
import socket from '../../../../services/socket';

export default function RevPerSellerWeek(props) {
    const [RevPerSellerWeek,setRevPerSellerWeek] = useState([]);
    const theme = useTheme();
    const store_id = props.store_id
    useEffect( () => {   
        function askRevPerSellerWeek(){
        socket.emit("/vezo/StoreInfo/askRevPerSellerWeek",{"store_id":store_id})
        }
        async function loadRevPerSellerWeek(){
            askRevPerSellerWeek()
            socket.on('/vezo/StoreInfo/updateRevPerSellerWeek/'+store_id,(data)=>{
            askRevPerSellerWeek()
            });
            socket.on('/vezo/StoreInfo/RevPerSellerWeek/'+store_id,(data)=>{
                // console.log("Recebi")
                setRevPerSellerWeek(data)
            });
            return () => socket.disconnect();
        }
        loadRevPerSellerWeek();    
        },[store_id]);

        
    return (
        <React.Fragment>
            <Grid container spacing={3}  justifyContent={"center"} direction="row">
            <Grid item xs={12} md={2} lg={1}>
                <Tooltip title="Faturamento por vendedor, nesta loja, nesta semana!">
                <IconButton aria-label="Selecionar" size="large">
                    <InfoIcon />
                </IconButton>
                </Tooltip>
            </Grid>
            <Grid item xs={12} md={10} lg={11}>
                <Title>Faturamento por vendedor</Title>
            </Grid>
            </Grid>
            <ResponsiveContainer>
                <BarChart data={RevPerSellerWeek}           
                margin={{
                    top: 16,
                    right: 16,
                    bottom: 0,
                    left: 24,
                }}>
                <TooltipRecharts isAnimationActive={true}/>
                <XAxis dataKey="day" stroke={theme.palette.text.secondary} />
                <YAxis stroke={theme.palette.text.secondary}>
                    <Label
                    angle={270}
                    position="left"
                    style={{ textAnchor: 'middle', fill: theme.palette.text.primary }}
                    >
                        Faturamento por vendedor
                    </Label>
                </YAxis>
                <Bar dataKey="RevPerSellerWeek" name="Faturamento por vendedor" fill="#8884d8" />
                </BarChart>
            </ResponsiveContainer>
        </React.Fragment>
    );
}
